function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.487 7.385c-.019-.08-.057-.154-.111-.216-.055-.061-.123-.109-.2-.138l-3.602-1.35.916-4.583c.022-.107.008-.218-.04-.316-.047-.098-.125-.178-.222-.227-.096-.05-.207-.067-.314-.048-.107.019-.205.072-.28.151l-7 7.5c-.056.06-.096.133-.117.213-.021.08-.023.163-.004.243.019.08.057.154.111.216.055.061.123.109.2.138l3.602 1.35-.916 4.584c-.022.106-.008.217.04.315.047.098.125.178.222.227.096.05.207.067.314.048.107-.019.205-.072.28-.151l7-7.5c.056-.06.096-.133.117-.213.021-.08.023-.163.004-.243z"
});

function SvgFrame10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#CCC",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame10);
export default __webpack_public_path__ + "static/media/Frame 10.2c00ba40.svg";
export { ForwardRef as ReactComponent };